var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 2C7.23 2 2.75 6.48 2.75 12C2.75 17.52 7.23 22 12.75 22C18.27 22 22.75 17.52 22.75 12C22.75 6.48 18.27 2 12.75 2ZM4.75 12C4.75 11.39 4.83 10.79 4.96 10.22L9.74 15V16C9.74 17.1 10.64 18 11.74 18V19.93C7.81 19.43 4.75 16.07 4.75 12ZM18.64 17.4C18.38 16.59 17.64 16 16.74 16H15.74V13C15.74 12.45 15.29 12 14.74 12H8.74V10H10.74C11.29 10 11.74 9.55 11.74 9V7H13.74C14.84 7 15.74 6.1 15.74 5V4.59C18.67 5.77 20.75 8.65 20.75 12C20.75 14.08 19.94 15.98 18.64 17.4Z",
    fill: "#2E72F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicIcon);
export default __webpack_public_path__ + "static/media/public-icon.1ff04c2c141478dde0a7280c4b321bf5.svg";
export { ForwardRef as ReactComponent };